module.exports = __webpack_public_path__ + "img/maximize.eccaefc2.svg";